(() => {
  let india = false;
  try { india = ['Asia/Kolkata', 'Asia/Calcutta'].includes(Intl.DateTimeFormat().resolvedOptions().timeZone); } catch (_) {}
  if (!india) {
    document.documentElement.classList.add('bina-native-checkout');
    return;
  }
  let scheduled = false;
  const refresh = () => {
    scheduled = false;
    document.querySelectorAll('.product-form__buttons, .cart__ctas').forEach((area) => {
      const widget = area.querySelector('.shiprocket-headless');
      const button = widget && widget.querySelector('button, a[href], [role="button"], .sr-headless-checkout');
      const add = area.querySelector('[name="add"]');
      const style = button && getComputedStyle(button);
      const ready = Boolean(button && !button.disabled && button.getAttribute('aria-disabled') !== 'true' &&
        (!add || !add.disabled) && button.getClientRects().length && style.display !== 'none' &&
        style.visibility !== 'hidden' && style.pointerEvents !== 'none');
      if (area.classList.contains('bina-checkout-ready') !== ready) area.classList.toggle('bina-checkout-ready', ready);
    });
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'disabled', 'aria-disabled', 'hidden']
  });
  window.addEventListener('resize', schedule, {passive: true});
  refresh();
})();
